module.exports = __webpack_public_path__ + "static/media/red-circle.be3acb5e.png";